<template>
    <div class="col-12">
        <div class="summary-container bg-light rounded p-3 mt-3 mb-mobile-section">
            <div class="row vertical-center">
                <div class="col-md-6 px-5 py-3 mobile-padding">
                    <div class="w-100 bg-transparent">
                        <div class="card-body px-0 pt-0">
                            <h4 class="mb-4 text-primary">{{ $t('shopEuropamaut.productSummaryTitle') }}</h4>
                            <div class="my-2" v-if="licensePlate">
                                <strong>{{ $t('shop.license_plate') }}</strong>
                                <span class="float-right">{{ licensePlate }}</span>
                                <br />
                            </div>
                            <template v-if="selectedProducts.length > 0">
                                <div
                                    class="my-2 mb-2"
                                    v-for="productData in selectedProducts"
                                    :key="productData.listingId"
                                >
                                    <strong class="float-right">
                                        {{ getProductName(productData.product) }}
                                    </strong>
                                    <small class="float-right" v-if="productData.validity">
                                        {{ getFormattedDate(productData.validity.from) }}
                                        -
                                        {{ getFormattedDate(productData.validity.until) }}
                                        23:59:59
                                    </small>
                                    <br />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 px-5 py-3 mobile-padding">
                    <div class="w-100 bg-transparent">
                        <div class="card-body px-0 d-flex flex-column justify-content-center">
                            <div class="row detailed-price-listing">
                                <div class="offset-lg-2"></div>
                                <div class="col-8 col-lg-6 text-left">
                                    {{ $t('shop.detailedPriceTitleToll') }}
                                </div>
                                <div class="col-4 col-lg-4 text-right">{{ getTollPrice(2) }} €</div>
                            </div>
                            <div class="row detailed-price-listing">
                                <div class="offset-lg-2"></div>
                                <div
                                    class="col-8 col-lg-6 text-left cursor-pointer"
                                    @click.prevent="$refs.serviceFeePopup.onShowModal()"
                                >
                                    {{ $t('shop.detailedPriceTitleService') }}
                                </div>
                                <div class="col-4 col-lg-4 text-right">
                                    <ServiceFeeInfo
                                        ref="serviceFeePopup"
                                        :service-fee="serviceFee - voucherDiscount"
                                        :show-lang="false"
                                    ></ServiceFeeInfo>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="offset-7 offset-lg-8"></div>
                                <div class="col-5 col-lg-4">
                                    <hr class="detailed-price-hr" />
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="offset-lg-2"></div>
                                <div class="col-7 col-md-6 col-lg-6">
                                    <div class="detailed-price-sum-title">
                                        {{ $t('shop.detailedPriceTitleSum') }}
                                    </div>
                                </div>
                                <div class="col-5 col-md-6 col-lg-4 text-right detailed-price-sum">
                                    <template v-if="voucher !== null">{{ getOrderPrice(2, true) }} €</template>
                                    <template v-else>{{ getOrderPrice(2) }} €</template>
                                </div>
                            </div>
                            <div class="row" v-if="source !== 'configurator'">
                                <div class="offset-lg-2"></div>
                                <div class="col-12 col-lg-10">
                                    <form
                                        action=""
                                        method="post"
                                        ref="voucherForm"
                                        class="justify-content-center row"
                                        @submit.prevent="submitVoucherForm"
                                    >
                                        <input type="hidden" name="product_type" :value="productType" />
                                        <div
                                            class="col-6 col-lg-8 px-3 px-md-0 px-lg-3 pt-0 form-group"
                                            v-if="!voucher"
                                        >
                                            <input
                                                type="text"
                                                name="voucher_code"
                                                :placeholder="$t('shop.voucher_placeholder')"
                                                class="form-control"
                                                :disabled="voucherLoading || voucher"
                                            />
                                        </div>
                                        <div
                                            class="col-6 col-lg-4 px-3 px-md-0 px-lg-3 pt-0 form-group text-right"
                                            v-if="!voucher"
                                        >
                                            <button
                                                class="btn btn-primary shop-voucher-btn px-3"
                                                :disabled="voucherLoading"
                                                @click="
                                                    $event.preventDefault();
                                                    submitVoucherForm();
                                                "
                                            >
                                                <span v-if="!voucherLoading && !voucher">{{
                                                    $t('shop.voucherBtn')
                                                }}</span>
                                                <span v-if="voucherLoading">
                                                    <i class="mdi mdi-spin mdi-loading mdi-18px"></i>
                                                </span>
                                                <span v-if="voucher && !voucherLoading">
                                                    <i class="mdi mdi-check mdi-18px"></i>
                                                </span>
                                            </button>
                                        </div>
                                        <div
                                            class="invalid-feedback d-block col-12 px-3 px-md-0 px-lg-3 pt-0"
                                            v-if="voucherError"
                                        >
                                            <span class="d-block">
                                                {{ voucherError }}
                                            </span>
                                        </div>
                                        <div
                                            class="row detailed-price-listing text-primary form-group max-width"
                                            v-if="voucherDiscount && voucher !== null"
                                        >
                                            <div class="col-12 col-lg-12 text-center font-weight-bold form-control">
                                                {{ voucherDiscount.toFixed(2) }} € {{ $t('shop.voucherApplied') }}
                                                <i class="mdi mdi-check mdi-18px price-listing-bold-icon"></i>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row mt-3" v-if="source === 'configurator' && url">
                                <div class="offset-lg-2"></div>
                                <div class="col-lg-10 col-12">
                                    <div class="checkbox-button-container">
                                        <a
                                            :href="url"
                                            target="_blank"
                                            type="button"
                                            class="label btn btn-primary btn-block"
                                        >
                                            <span v-html="$t('configurator.continueToOrder')"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceFeeInfo from '../Order/ServiceFeeInfo.vue';

export default {
    name: 'ProductSummary',
    components: { ServiceFeeInfo },

    props: ['licensePlate', 'selectedProducts', 'source', 'url'],

    emits: [],

    data() {
        return {
            orderPrice: 0,
            serviceFee: 0,
            productType: 'combined_order',
            voucherLoading: false,
            voucherError: '',
            voucher: null,
        };
    },

    methods: {
        getTollPrice(digits) {
            return (this.orderPrice - this.serviceFee).toFixed(digits);
        },

        getOrderPrice(digits, withDiscount = false) {
            let price = this.orderPrice;

            if (withDiscount) {
                price -= Math.max(0, this.voucherDiscount);
            }

            if ('number' === typeof digits && !isNaN(digits) && digits >= 0) {
                return price.toFixed(digits);
            }

            return price;
        },

        getProductName(product) {
            return product.names[this.$language] ?? product.names['en'];
        },

        getFormattedDate(date, separator = '-') {
            if (!date) {
                return;
            }

            // Return a readable date to display.
            const parts = date.split(separator);
            return `${parts[2]}.${parts[1]}.${parts[0]}`;
        },

        submitVoucherForm() {
            const form = new FormData(this.$refs.voucherForm);
            if (!form.has('voucher_code') || form.get('voucher_code').length === 0 || this.voucher) {
                return;
            }

            this.voucherLoading = true;
            this.voucherError = '';

            axios
                .post('/' + this.$language + '/backend/validate/voucher', form)
                .then((response) => {
                    if (response.data.valid) {
                        this.voucher = response.data.voucher;
                        this.$emit('voucher-mounted', response.data.voucher);
                    } else if (response.data.errors && response.data.errors.voucher_code) {
                        this.voucherError = response.data.errors.voucher_code[0];
                    } else {
                        throw new Error('Invalid voucher');
                    }
                })
                .catch(() => {
                    this.voucherError = this.$t('shop.voucher_invalid');
                })
                .then(() => {
                    this.voucherLoading = false;
                    this.$refs.voucherForm.reset();
                });
        },
    },

    watch: {
        selectedProducts() {
            this.serviceFee = 0;
            this.orderPrice = 0;
            this.selectedProducts.forEach((productData) => {
                this.serviceFee += productData.option.serviceFee;
                this.orderPrice += productData.option.price;
            });
        },
    },

    computed: {
        voucherDiscount() {
            if (this.voucher === null) return 0;

            switch (this.voucher.type) {
                case 'fixed':
                    return this.voucher.amount;
                case 'percentage':
                    return (this.serviceFee * this.voucher.amount) / 100;
            }

            return 0;
        },
    },

    mounted() {
        if (this.source === 'configurator') {
            this.serviceFee = 0;
            this.orderPrice = 0;
            this.selectedProducts.forEach((productData) => {
                this.serviceFee += productData.option.serviceFee;
                this.orderPrice += productData.option.price;
            });
        }
    },
};
</script>
